export default "__VITE_ASSET__zXEtcoQL__"